import { render, staticRenderFns } from "./sealTestCommon.vue?vue&type=template&id=cbefc02e&scoped=true"
import script from "./sealTestCommon.vue?vue&type=script&lang=js"
export * from "./sealTestCommon.vue?vue&type=script&lang=js"
import style0 from "./sealTestCommon.vue?vue&type=style&index=0&id=cbefc02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbefc02e",
  null
  
)

export default component.exports